
import { Helmet } from "react-helmet";
import Pricing from "@/components/Pricing";

import MainLayout from "@/components/layout/MainLayout";
import BackButton from "@/components/common/BackButton";

const PricingPage = () => {
  return (
    <>
      <Helmet>
        <title>Cennik Detailing Poznań Wilda | Ceny od 79zł | 061 Garage</title>
        <meta 
          name="description" 
          content="Cennik detailing Poznań Wilda od 79zł! Mycie zewnętrzne, pranie tapicerki, detailing wnętrza. Konkurencyjne ceny, mobilny serwis. Tel: 602 709 327" 
        />
        <meta name="keywords" content="cennik detailing Poznań Wilda, ceny mycia aut Poznań, koszt prania tapicerki, ile kosztuje detailing, cennik 061 garage, detailing od 79zł" />
        <link rel="canonical" href="https://061garagedetailingstudio.pl/cennik" />
        <meta property="og:title" content="Cennik Detailing Poznań Wilda | Ceny od 79zł | 061 Garage" />
        <meta property="og:description" content="Sprawdź najlepsze ceny detailingu w Poznaniu! Od 79zł mycie, pranie tapicerki. Mobilny serwis. Zadzwoń: 602 709 327" />
        <meta property="og:url" content="https://061garagedetailingstudio.pl/cennik" />
        <meta property="og:image" content="https://061garagedetailingstudio.pl/lovable-uploads/5f17a190-693b-4d81-b673-957c3b473247.png" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="pl_PL" />
        <meta property="og:site_name" content="061 Garage Detailing Studio" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Cennik Detailing Poznań Wilda | Ceny od 79zł | 061 Garage" />
        <meta name="twitter:description" content="Sprawdź najlepsze ceny detailingu w Poznaniu! Od 79zł mycie, pranie tapicerki. Mobilny serwis. Zadzwoń: 602 709 327" />
        <meta name="twitter:image" content="https://061garagedetailingstudio.pl/lovable-uploads/5f17a190-693b-4d81-b673-957c3b473247.png" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "PriceSpecification",
            "name": "Cennik usług detailingu samochodowego",
            "description": "Cennik profesjonalnych usług detailingu w Poznaniu",
            "provider": {
              "@type": "LocalBusiness",
              "name": "061 Garage Detailing Studio"
            }
          })}
        </script>
      </Helmet>
      <BackButton />  
      <MainLayout>
        <div className="pt-24 md:pt-28">
          <Pricing />
        </div>
      </MainLayout>
    </>
  );
};

export default PricingPage;
